import { SafeHtml } from "@angular/platform-browser";

export class Content {
  processedIcon: SafeHtml;
  constructor(public title: string, public icon: string, public body: string) { }
}